const e=e=>`mf-${e}`;export{e as getMobileFontSizeClassName};
//# sourceMappingURL=get-mobile-font-size-class-name.js.map